import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import type { DealCompanySetting } from "~/models/CompanySetting";
import { convertToComboBoxOption } from "~/models/CompanySetting";
import type { DealSearchCondition } from "~/models/Deal";

type Props = {
	maintenanceCompanies: DealCompanySetting[] | null;
};

export function MaintenanceCompanyCombobox({ maintenanceCompanies }: Props) {
	const { setValue, watch } = useFormContext<DealSearchCondition>();
	const watchedCompanyMasterId = watch("companyMasterId");

	const selectedMaintenanceCompanyOption = useMemo((): ComponentProps<
		typeof SingleComboBox
	>["value"] => {
		const company = maintenanceCompanies?.find(
			({ companyMasterId }) => companyMasterId === watchedCompanyMasterId
		);
		return company ? convertToComboBoxOption(company) : null;
	}, [maintenanceCompanies, watchedCompanyMasterId]);

	const onValueChange: Required<
		ComponentProps<typeof SingleComboBox>
	>["onChange"] = useCallback(
		(value) => {
			const companyMasterId = value ? Number(value.value) : undefined;
			setValue("companyMasterId", companyMasterId);
		},
		[setValue]
	);

	return (
		<SingleComboBox
			onChange={onValueChange}
			options={
				maintenanceCompanies?.map((cs: DealCompanySetting) =>
					convertToComboBoxOption(cs)
				) ?? []
			}
			placeholder="管理会社"
			value={selectedMaintenanceCompanyOption}
		/>
	);
}
